module.exports = __webpack_public_path__ + "static/media/mendel_logo.15edb274.png";